import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { BehaviourSubjectService } from '../../services/behaviour-subject.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit, OnDestroy {
  private pendingNavigationUrl: string | null = null;
  private readonly subscriptions = new Subscription();

  constructor(
    private router: Router,
    private authService: AuthService,
    private behaviourSubject: BehaviourSubjectService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.authService.isLoggedIn$.subscribe((isLoggedIn) => {
        if (isLoggedIn && this.pendingNavigationUrl) {
          const target = this.pendingNavigationUrl;
          this.pendingNavigationUrl = null;
          this.navigateToProtectedRoute(target);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  navigateToRefundPolicy() {
    this.router.navigate(['/terms-condition'], { queryParams: { tab: 'returns' } });
  }

  gotoproductList(type: string): void {
    localStorage.removeItem('category');
    localStorage.removeItem('filterState');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('seemore');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('mostSearchedModel');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('MyGarageData');
    localStorage.setItem('categoryType', JSON.stringify(type));

    if (this.router.url.startsWith('/product-list')) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/product-list']);
      });
    } else {
      this.router.navigate(['/product-list']);
    }
  }

  handleProtectedNavigation(event: Event, route: string): void {
    event.preventDefault();

    if (this.authService.isLoggedIn) {
      this.navigateToProtectedRoute(route);
      return;
    }

    this.pendingNavigationUrl = route;
    this.behaviourSubject.openLoginModal('other');
  }

  private navigateToProtectedRoute(route: string): void {
    if (this.router.url === route) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl(route);
      });
    } else {
      this.router.navigateByUrl(route);
    }
  }
}
